// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';
import { Grid, Box, Card, Typography } from '@mui/material';

import Logo from '@/layouts/full/shared/logo/Logo';

import AuthTwoSteps from '@/components/authForms/AuthTwoSteps';

const TwoSteps = () => (
  <Box
    sx={{
      position: 'relative',
      '&:before': {
        content: '""',
        background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
        backgroundSize: '400% 400%',
        animation: 'gradient 15s ease infinite',
        position: 'absolute',
        height: '100%',
        width: '100%',
        opacity: '0.3',
      },
    }}
  >
    <Grid
      container
      spacing={0}
      justifyContent="center"
      sx={{ height: '100vh' }}
    >
      <Grid
        display="flex"
        justifyContent="center"
        alignItems="center"
        size={{
          xs: 12,
          sm: 12,
          lg: 5,
          xl: 4,
        }}
      >
        <Card
          elevation={9}
          sx={{ p: 4, zIndex: 1, width: '100%', maxWidth: '450px' }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <Logo />
          </Box>
          <Typography
            variant="subtitle1"
            textAlign="center"
            color="textSecondary"
            mb={1}
            mt={2}
          >
            We sent a verification code to your email. Enter the code in the
            field below.
          </Typography>
          <AuthTwoSteps />
        </Card>
      </Grid>
    </Grid>
  </Box>
);

export default TwoSteps;
